import { ForwardedRef, forwardRef } from 'react';

import { InputSize } from '@xemplo/input-utils';
import { XemploInput } from '@xemplo/xemplo-input';

import { TextFieldProps } from './text-field.types';

/**
 * TextField is a specialized input component that renders a text input field.
 * It extends the functionality of the XemploInput component, allowing for
 * additional properties specific to text fields.
 *
 * @param props - The properties for the TextField component.
 * @returns A styled text input element with optional label, icons, and error handling.
 */
export const TextField = forwardRef(
  (props: TextFieldProps, ref?: ForwardedRef<HTMLInputElement>) => {
    return (
      <XemploInput
        {...props}
        ref={ref}
        inputSize={props.inputSize ?? InputSize.Default}
        type={props.hidden ? 'hidden' : 'text'}
      />
    );
  },
);
